module.exports = __webpack_public_path__ + "static/media/reports.7811473b.svg";